import React from 'react';
import { Card, Statistic } from 'antd';

const SummaryCard = ({ 
  title, 
  value, 
  icon, 
  prefix,
  suffix,
  precision,
  valueStyle = {},
  loading = false,
  bordered = true,
  hoverable = true,
  size = 'default',
  onClick = null,
  ...props 
}) => {
  const cardProps = {
    bordered,
    hoverable: hoverable || !!onClick,
    size,
    style: onClick ? { cursor: 'pointer' } : {},
    onClick,
    ...props
  };

  return (
    <Card {...cardProps}>
      <Statistic
        title={title}
        value={value}
        prefix={icon || prefix}
        suffix={suffix}
        precision={precision}
        valueStyle={valueStyle}
        loading={loading}
      />
    </Card>
  );
};

export default SummaryCard;
